import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ClientListPanel from '../components/panels/ClientListPanel';
import connectionService from '../../services/connectionService';
import tagService from '../../services/tagService';
import useAdmins from '../../hooks/business/useAdmins';
import adminService from '../../services/adminService';
import usePersonalConnections from '../../hooks/account/usePersonalConnections';
import userService from '../../services/userService';
import inviteService from '../../services/inviteService';
import useBusinessEffect from '../../hooks/effects/useBusinessEffect';

/*
 * This page is used to display the dashboard, the main page
 */
export default function ContactsPage(): JSX.Element {
  const admins = useAdmins();
  const personalConnections = usePersonalConnections();
  const location = useLocation();
  const navigate = useNavigate();
  const [showInviteModal, setShowInviteModal] = React.useState<boolean>(false);
  const [openInviteModal, setOpenInviteModal] = React.useState<boolean | undefined>(location.state?.openInviteModal);

  React.useEffect(() => {
    if (openInviteModal) {
      setShowInviteModal(true);
      navigate(location.pathname, { replace: true });
      setOpenInviteModal(undefined);
    }
  }, [openInviteModal, navigate, location.pathname]);

  useBusinessEffect((): void => {
    connectionService.getConnections();
    tagService.fetchTags();
    inviteService.fetchInvite();
    if (admins.length === 0) {
      adminService.getAllAdmins();
      adminService.getAllAdminInvites();
    }
    if (personalConnections.length === 0) {
      userService.getConnections();
    }
  }, []);

  return <ClientListPanel showInviteModalInitially={showInviteModal}/>;
}
